import React from 'react';
import classnames from 'classnames';

const UserAvatar: React.FC<{
  avatar: string;
  text: string;
  initials: string;
  onlyAvatar?: boolean;
  multiple?: boolean;
  onRemove?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
}> = ({ avatar, initials, text, onlyAvatar, multiple, onRemove }) => {
  return (
    <div
      className={classnames('tw-flex tw-items-center tw-gap-1', {
        'tw-border tw-border-primary-border tw-border-solid tw-pr-2 tw-rounded-xl tw-h-5':
          multiple && !onlyAvatar,
      })}
    >
      <aha-avatar
        class='!tw-box-border !tw-m-0 !tw-transform-none'
        size={18}
        src={avatar || null}
        name={text}
        label={initials}
      />
      {!onlyAvatar && <span>{text}</span>}
      {multiple && !onlyAvatar && (
        <a onClick={onRemove}>
          <i
            className='fa-solid fa-xmark tw-text-xs tw-cursor-pointer tw-text-[--theme-tertiary-text] tw-ml-1'
            aria-label={`Remove ${text}`}
          />
        </a>
      )}
    </div>
  );
};

export default UserAvatar;
